// extracted by mini-css-extract-plugin
export default {"contentColumn":"CalendarioSider_contentColumn__CYbfL","sideContainer":"CalendarioSider_sideContainer__bg3C6","crearHeader":"CalendarioSider_crearHeader__Ikfmd"};